import React,{Component} from 'react';
import {Modal,Button,Row,Col,Form} from 'react-bootstrap';
import axios from 'axios';

export  class EditTaskHeaderModal extends Component{
    constructor(props){
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {
            TaskList:[]
            
        }
      

    }
    componentDidMount() {
        
        
    }  
    
  
      
    handleSubmit(event){
        event.preventDefault();
        const options = {
            headers: {"content-type": "text/plain"}
        }
    const article = { taskheaderid:event.target.taskheaderid.value,
        taskheadername:event.target.taskheadername.value,username:this.props.username  };
    axios.post('https://as-mobilization.accenture.com/KTPlanConfig/api/AdminTaskHeader/PostHeader', article, options)
    .then((result)=> {            
        alert("Data saved successfully");
        this.props.filterchangetest(this.props.servicegroup,this.props.scope,this.props.level);
         },
         (error) => {
             alert('Failed to save data');
       }) 
       


    }

    render(){
        return (
            <div className='container'>
            <Modal  {...this.props} size='lg'  aria-labelledby='contained-modal-title-vcenter' centered >
                <Modal.Header>
                <Modal.Title id='contained-modal-title-vcenter'>
                    Add Task
                </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm={12}>
                          <Form onSubmit={this.handleSubmit}>

                          <Form.Group controlId='taskheader'>
                              <div class="col-md-4" style={{display:'none'}}>
                              <Form.Label>TaskHeaderId</Form.Label>
                              <Form.Control type='text' style={{width:140}} name='taskheaderid' required
                              disabled defaultValue={this.props.taskheaderid} ></Form.Control>
                              </div>
                           
                              
                          </Form.Group> 

                          <Form.Group controlId='taskheader'>
                              <div class="col-md-12" >
                              <Form.Label>Task Header Name*</Form.Label>
                              <Form.Control type='text' maxLength={100} style={{width:275}} defaultValue={this.props.taskheadername} name='taskheadername' required ></Form.Control>
                              </div>
                             
                             
                             
                             
                          </Form.Group>  
                          <Form.Group>
                              <Button variant='primary' style={{margin:10}} className='btn-new btn-confirm' type='submit'>
                                  Save
                              </Button> 
                              <Button onClick={this.props.onHide} style={{margin:10,backgroundColor:'gray'}} className='btn-new btn-confirm' >Close
                              </Button> 
                          </Form.Group>  
                          </Form>  
                        </Col>
                    </Row>
                </Modal.Body>
            
            </Modal>
            </div>
        )
    }
}